/*
 * DO NOT EDIT THIS FILE DIRECTLY
 * This file is generated from the generate-iconset command.
 * See icon-master-list.js for instructions
 */

import React from "react";
import { IconProvider } from "./icon";
import { IconShape } from "./icon-shape";

/**
 * The Icon Provider that contains all of the available Icons this application
 * utilizes.
 */
export const Icons: IconProvider = {
  [IconShape.NEW_ICON_NAME]: {
    baseWidth: 14,
    baseHeight: 14,
    render: (_color) => (
      <React.Fragment>
        <path
          d="M7 0.320312L13.6797 7L7 13.6797L5.82812 12.5078L10.4766 7.82031H0.320312V6.17969H10.4766L5.82812 1.49219L7 0.320312Z"
          fill="url(#paint0_linear_1503_6721)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1503_6721"
            x1="17"
            y1="7.05926"
            x2="-3"
            y2="7.05926"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E5506A" />
            <stop offset="1" stopColor="#8B42C4" />
          </linearGradient>
        </defs>
      </React.Fragment>
    ),
  },
  [IconShape.THUMBS_UP]: {
    baseWidth: 19,
    baseHeight: 19,
    render: (color) => (
      <React.Fragment>
        <path
          d="M2.61108 15.3058H5.29795V7.38911H2.61108V15.3058ZM17.3889 8.04883C17.3889 7.32313 16.7843 6.72938 16.0454 6.72938H11.8069L12.445 3.71445L12.4652 3.50334C12.4652 3.23286 12.351 2.98216 12.1696 2.80404L11.4576 2.11133L7.0377 6.4589C6.78917 6.6964 6.64139 7.02626 6.64139 7.38911V13.9863C6.64139 14.712 7.24593 15.3058 7.98482 15.3058H14.0303C14.5878 15.3058 15.0647 14.9759 15.2662 14.5009L17.2948 9.84987C17.3553 9.69813 17.3889 9.5398 17.3889 9.36827V8.04883Z"
          fill={color}
          stroke="none"
        />
      </React.Fragment>
    ),
  },
  [IconShape.FOOTBALL]: {
    baseWidth: 20,
    baseHeight: 20,
    render: (color) => (
      <React.Fragment>
        <g fill={color} stroke="none">
          <path d="M1.0114 13.8252C0.926871 16.3823 1.34954 18.4111 1.71937 18.7809C2.0892 19.1508 4.12856 19.584 6.67512 19.4889L1.0114 13.8252Z" />
          <path d="M11.6414 0.786133C9.17941 1.22993 6.58002 2.20206 4.64632 4.14632C2.71263 6.09058 1.72993 8.67941 1.28613 11.1414L9.34848 19.2038C11.8211 18.7705 14.4099 17.7879 16.3436 15.8436C18.2773 13.8993 19.26 11.3105 19.7038 8.84848L11.6414 0.786133ZM8.28125 13.6986L6.80192 12.2192L12.7192 6.30192L14.1986 7.78125L8.28125 13.6986Z" />
          <path d="M19.9894 6.17507C20.0739 3.61794 19.6513 1.58915 19.2814 1.21932C18.9116 0.849486 16.8722 0.416253 14.3257 0.511353L19.9894 6.17507Z" />
        </g>
      </React.Fragment>
    ),
  },
  [IconShape.ACCOUNT_TREE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z"
          fill={color}
          stroke="none"
        />
      </React.Fragment>
    ),
  },
  [IconShape.ADD_CIRCLE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.ADD]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill={color} />
      </React.Fragment>
    ),
  },
  [IconShape.ARROW_DOWNWARD]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.ARROW_RIGHT]: {
    baseWidth: 10,
    baseHeight: 10,
    render: (color) => (
      <React.Fragment>
        <path
          d="M5 0.324219L9.67578 5L5 9.67578L4.17969 8.85547L7.43359 5.57422H0.324219V4.42578H7.43359L4.17969 1.14453L5 0.324219Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.ARROW_LEFT]: {
    baseWidth: 22,
    baseHeight: 22,
    render: (color) => (
      <React.Fragment>
        <path
          d="M21.0195 9.76953V12.2305H5.78516L12.7578 19.2617L11 21.0195L0.980469 11L11 0.980469L12.7578 2.73828L5.78516 9.76953H21.0195Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.AUTO_AWESOME]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.BOLT]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.CALENDAR_TODAY]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.CHECK]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.CIRCLE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.CLOSE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.CONTENT_COPY]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.CREDIT_CARD]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.DASHBOARD]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.DELETE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.DRAG_INDICATOR]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.EDIT_NOTE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M3 10h11v2H3v-2zm0-2h11V6H3v2zm0 8h7v-2H3v2zm15.01-3.13.71-.71a.996.996 0 0 1 1.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.71-2.12-2.12zm-.71.71-5.3 5.3V21h2.12l5.3-5.3-2.12-2.12z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.EDIT]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.EMAIL]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.FLAG]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path d="M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6z" fill={color} />
      </React.Fragment>
    ),
  },
  [IconShape.FAVORITE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.FILE_DOWNLOAD]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill={color} />
      </React.Fragment>
    ),
  },
  [IconShape.FILTER_LIST]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" fill={color} />
      </React.Fragment>
    ),
  },
  [IconShape.FOLDER]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.FULLSCREEN]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.GAMEPAD]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.HAMBURGER_MENU]: {
    baseWidth: 16,
    baseHeight: 10,
    render: (color) => (
      <React.Fragment>
        <path
          d="M0.5 0H15.5V1.67969H0.5V0ZM0.5 5.82031V4.17969H15.5V5.82031H0.5ZM0.5 10V8.32031H15.5V10H0.5Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.HELP]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.IMAGE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.INFO]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.INSIGHTS]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M21 8c-1.45 0-2.26 1.44-1.93 2.51l-3.55 3.56c-.3-.09-.74-.09-1.04 0l-2.55-2.55C12.27 10.45 11.46 9 10 9c-1.45 0-2.27 1.44-1.93 2.52l-4.56 4.55C2.44 15.74 1 16.55 1 18c0 1.1.9 2 2 2 1.45 0 2.26-1.44 1.93-2.51l4.55-4.56c.3.09.74.09 1.04 0l2.55 2.55C12.73 16.55 13.54 18 15 18c1.45 0 2.27-1.44 1.93-2.52l3.56-3.55c1.07.33 2.51-.48 2.51-1.93 0-1.1-.9-2-2-2z"
          fill={color}
        />
        <path
          d="m15 9 .94-2.07L18 6l-2.06-.93L15 3l-.92 2.07L12 6l2.08.93zM3.5 11 4 9l2-.5L4 8l-.5-2L3 8l-2 .5L3 9z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.KEYBOARD_ARROW_DOWN]: {
    baseWidth: 12,
    baseHeight: 8,
    render: (color) => (
      <React.Fragment>
        <path
          d="M1.98732 0.5L6.32909 4.84177L10.6709 0.5L12 1.82911L6.32909 7.5L0.658203 1.82911L1.98732 0.5Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.KEYBOARD_ARROW_LEFT]: {
    baseWidth: 19,
    baseHeight: 30,
    render: (color) => (
      <React.Fragment>
        <path
          d="M15 0L0 15L15 30L18.5156 26.4844L7.03125 15L18.5156 3.51562L15 0Z"
          fill={color}
          stroke="none"
        />
      </React.Fragment>
    ),
  },
  [IconShape.KEYBOARD_ARROW_RIGHT]: {
    baseWidth: 19,
    baseHeight: 31,
    render: (color) => (
      <React.Fragment>
        <path
          d="M4 0.5L19 15.5L4 30.5L0.484375 26.9844L11.9688 15.5L0.484375 4.01562L4 0.5Z"
          fill={color}
          stroke="none"
        />
      </React.Fragment>
    ),
  },
  [IconShape.KEYBOARD_ARROW_UP]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z" fill={color} />
      </React.Fragment>
    ),
  },
  [IconShape.LABEL]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.LIST]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.LOCK]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.LIGHTBULB]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9v1zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.LOGOUT]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.MAIL]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.PALETTE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10a2.5 2.5 0 0 0 2.5-2.5c0-.61-.23-1.2-.64-1.67a.528.528 0 0 1-.13-.33c0-.28.22-.5.5-.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9zm5.5 11c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm-3-4c-.83 0-1.5-.67-1.5-1.5S13.67 6 14.5 6s1.5.67 1.5 1.5S15.33 9 14.5 9zM5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S7.33 13 6.5 13 5 12.33 5 11.5zm6-4c0 .83-.67 1.5-1.5 1.5S8 8.33 8 7.5 8.67 6 9.5 6s1.5.67 1.5 1.5z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.PERCENT]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M7.5 11C9.43 11 11 9.43 11 7.5S9.43 4 7.5 4 4 5.57 4 7.5 5.57 11 7.5 11zm0-5C8.33 6 9 6.67 9 7.5S8.33 9 7.5 9 6 8.33 6 7.5 6.67 6 7.5 6zM4.002 18.583 18.59 3.996l1.414 1.414L5.417 19.997zM16.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.PERSON]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.PHONE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.PRIORITY_HIGH]: {
    baseWidth: 20,
    baseHeight: 20,
    render: (color) => (
      <React.Fragment>
        <path
          d="M8.82422 4.75H11.1758V11.75H8.82422V4.75ZM9.15234 14.9219C8.93359 14.6849 8.82422 14.4023 8.82422 14.0742C8.82422 13.7461 8.93359 13.4727 9.15234 13.2539C9.38932 13.0352 9.67188 12.9258 10 12.9258C10.3281 12.9258 10.6016 13.0352 10.8203 13.2539C11.0573 13.4727 11.1758 13.7461 11.1758 14.0742C11.1758 14.4023 11.0573 14.6849 10.8203 14.9219C10.6016 15.1406 10.3281 15.25 10 15.25C9.67188 15.25 9.38932 15.1406 9.15234 14.9219Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.PUBLISH]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path d="M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z" fill={color} />
      </React.Fragment>
    ),
  },
  [IconShape.REDEEM]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.REPLAY]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.SEARCH]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.SELL]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="m21.41 11.41-8.83-8.83c-.37-.37-.88-.58-1.41-.58H4c-1.1 0-2 .9-2 2v7.17c0 .53.21 1.04.59 1.41l8.83 8.83c.78.78 2.05.78 2.83 0l7.17-7.17c.78-.78.78-2.04-.01-2.83zM6.5 8C5.67 8 5 7.33 5 6.5S5.67 5 6.5 5 8 5.67 8 6.5 7.33 8 6.5 8z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.SETTINGS]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.488.488 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.SHARE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M14.9825 6.01754L13.9298 7.07018L12.7368 5.87719V14.2281H11.2632V5.87719L10.0702 7.07018L9.01754 6.01754L12 3L14.9825 6.01754ZM18 9.73684V17.9825C18 18.4035 17.848 18.7661 17.5439 19.0702C17.2632 19.3509 16.9123 19.4912 16.4912 19.4912H7.50877C7.08772 19.4912 6.72515 19.3509 6.42105 19.0702C6.14035 18.7661 6 18.4035 6 17.9825V9.73684C6 9.33918 6.14035 9 6.42105 8.7193C6.72515 8.4152 7.08772 8.26316 7.50877 8.26316H9.75439V9.73684H7.50877V17.9825H16.4912V9.73684H14.2456V8.26316H16.4912C16.9123 8.26316 17.2632 8.4152 17.5439 8.7193C17.848 9 18 9.33918 18 9.73684Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.SPACE_DASHBOARD]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M11 21H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h6v18zm2 0h6c1.1 0 2-.9 2-2v-7h-8v9zm8-11V5c0-1.1-.9-2-2-2h-6v7h8z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.SPEED]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="m20.38 8.57-1.23 1.85a8 8 0 0 1-.22 7.58H5.07A8 8 0 0 1 15.58 6.85l1.85-1.23A10 10 0 0 0 3.35 19a2 2 0 0 0 1.72 1h13.85a2 2 0 0 0 1.74-1 10 10 0 0 0-.27-10.44zm-9.79 6.84a2 2 0 0 0 2.83 0l5.66-8.49-8.49 5.66a2 2 0 0 0 0 2.83z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.SPORTS_ESPORTS]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="m21.58 16.09-1.09-7.66A3.996 3.996 0 0 0 16.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66a2.545 2.545 0 0 0 4.32 2.16L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91zM11 11H9v2H8v-2H6v-1h2V8h1v2h2v1zm4-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.STAR]: {
    baseWidth: 20,
    baseHeight: 20,
    render: (color) => (
      <React.Fragment>
        <path
          d="M10 15.6779L16.18 19.3976L14.54 12.387L20 7.67014L12.81 7.06183L10 0.450195L7.19 7.06183L0 7.67014L5.46 12.387L3.82 19.3976L10 15.6779Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.SUBDIRECTORY_ARROW_RIGHT]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="m19 15-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.TITLE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path d="M5 4v3h5.5v12h3V7H19V4z" fill={color} />
      </React.Fragment>
    ),
  },
  [IconShape.TERMINAL]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16c1.1 0 2-.9 2-2V6a2 2 0 0 0-2-2zm0 14H4V8h16v10zm-2-1h-6v-2h6v2zM7.5 17l-1.41-1.41L8.67 13l-2.59-2.59L7.5 9l4 4-4 4z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.TRENDING_UP]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.TRENDING_DOWN]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="m16 18 2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.TRIANGLE_RIGHT]: {
    baseWidth: 20,
    baseHeight: 20,
    render: (color) => (
      <React.Fragment>
        <path
          d="M6.67969 4.17969L15.8203 10L6.67969 15.8203V4.17969Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.TRIANGLE_DOWN]: {
    baseWidth: 10,
    baseHeight: 6,
    render: (color) => (
      <React.Fragment>
        <path d="M0 0.5H10L5 5.5L0 0.5Z" fill={color} />
      </React.Fragment>
    ),
  },
  [IconShape.UPLOAD_FILE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.WEB]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.TEXT_BLOCK]: {
    baseWidth: 8,
    baseHeight: 6,
    render: (color) => (
      <React.Fragment>
        <path
          d="M3.3708 0.535156C2.98248 0.546181 2.60014 0.633675 2.24567 0.792633C1.8912 0.951591 1.57155 1.17889 1.30503 1.46152C1.03851 1.74416 0.830335 2.07658 0.692431 2.43976C0.554526 2.80293 0.489595 3.18974 0.501354 3.57805V3.95536C0.501354 4.25267 0.589514 4.54329 0.754687 4.79049C0.919859 5.03769 1.15462 5.23036 1.4293 5.34413C1.70397 5.4579 2.00621 5.48767 2.2978 5.42967C2.58939 5.37167 2.85723 5.2285 3.06746 5.01828C3.27768 4.80805 3.42084 4.54021 3.47885 4.24862C3.53685 3.95703 3.50708 3.65479 3.39331 3.38012C3.27953 3.10545 3.08687 2.87068 2.83967 2.70551C2.59247 2.54034 2.30184 2.45218 2.00454 2.45218C1.89062 2.45227 1.77716 2.46658 1.66678 2.49478C1.65238 2.49887 1.63706 2.49845 1.62291 2.49355C1.60876 2.48865 1.59645 2.47952 1.58767 2.46739C1.57954 2.45467 1.57522 2.43989 1.57522 2.42479C1.57522 2.40969 1.57954 2.39491 1.58767 2.38219C1.76262 2.0599 2.01974 1.78964 2.33291 1.59885C2.64608 1.40806 3.00417 1.30353 3.3708 1.29588C3.47168 1.29588 3.56842 1.2558 3.63976 1.18447C3.71109 1.11314 3.75116 1.0164 3.75116 0.915517C3.75116 0.814639 3.71109 0.717893 3.63976 0.646561C3.56842 0.57523 3.47168 0.535156 3.3708 0.535156Z"
          fill={color}
          stroke="none"
        />
        <path
          d="M7.11982 1.29588C7.2207 1.29588 7.31745 1.2558 7.38878 1.18447C7.46011 1.11314 7.50018 1.0164 7.50018 0.915517C7.50018 0.814639 7.46011 0.717893 7.38878 0.646561C7.31745 0.57523 7.2207 0.535156 7.11982 0.535156C6.7315 0.546181 6.34916 0.633675 5.99469 0.792633C5.64022 0.951591 5.32058 1.17889 5.05405 1.46152C4.78753 1.74416 4.57936 2.07658 4.44145 2.43976C4.30355 2.80293 4.23862 3.18974 4.25038 3.57805V3.95536C4.24978 4.25353 4.33768 4.54516 4.50295 4.79332C4.66823 5.04149 4.90344 5.23502 5.17879 5.3494C5.45414 5.46378 5.75725 5.49386 6.04971 5.43584C6.34217 5.37782 6.61084 5.2343 6.82167 5.02347C7.0325 4.81264 7.17602 4.54397 7.23404 4.25151C7.29206 3.95905 7.26198 3.65594 7.1476 3.38059C7.03322 3.10524 6.83969 2.87003 6.59153 2.70475C6.34336 2.53948 6.05173 2.45157 5.75356 2.45218C5.63966 2.45246 5.52622 2.46677 5.4158 2.49478C5.4014 2.49887 5.38608 2.49845 5.37193 2.49355C5.35778 2.48865 5.34548 2.47952 5.33669 2.46739C5.32856 2.45467 5.32424 2.43989 5.32424 2.42479C5.32424 2.40969 5.32856 2.39491 5.33669 2.38219C5.51164 2.0599 5.76876 1.78964 6.08193 1.59885C6.39511 1.40806 6.75319 1.30353 7.11982 1.29588Z"
          fill={color}
          stroke="none"
        />
      </React.Fragment>
    ),
  },
  [IconShape.TEXT_INPUT]: {
    baseWidth: 10,
    baseHeight: 6,
    render: (color) => (
      <React.Fragment>
        <path
          d="M10 1.33301C10 1.00149 9.8683 0.683545 9.63388 0.449124C9.39946 0.214704 9.08152 0.0830078 8.75 0.0830078H1.25C0.918479 0.0830078 0.600537 0.214704 0.366116 0.449124C0.131696 0.683545 0 1.00149 0 1.33301L0 4.66634C0 4.99786 0.131696 5.3158 0.366116 5.55023C0.600537 5.78465 0.918479 5.91634 1.25 5.91634H8.75C9.08152 5.91634 9.39946 5.78465 9.63388 5.55023C9.8683 5.3158 10 4.99786 10 4.66634V1.33301ZM9.16667 4.66634C9.16667 4.77685 9.12277 4.88283 9.04463 4.96097C8.96649 5.03911 8.86051 5.08301 8.75 5.08301H1.25C1.13949 5.08301 1.03351 5.03911 0.955372 4.96097C0.877232 4.88283 0.833333 4.77685 0.833333 4.66634V1.33301C0.833333 1.2225 0.877232 1.11652 0.955372 1.03838C1.03351 0.96024 1.13949 0.916341 1.25 0.916341H8.75C8.86051 0.916341 8.96649 0.96024 9.04463 1.03838C9.12277 1.11652 9.16667 1.2225 9.16667 1.33301V4.66634Z"
          fill={color}
          stroke="none"
        />
        <path
          d="M3.33317 2.16634C3.44368 2.16634 3.54966 2.12244 3.6278 2.0443C3.70594 1.96616 3.74984 1.86018 3.74984 1.74967C3.74984 1.63917 3.70594 1.53319 3.6278 1.45505C3.54966 1.37691 3.44368 1.33301 3.33317 1.33301H2.08317C1.97266 1.33301 1.86668 1.37691 1.78854 1.45505C1.7104 1.53319 1.6665 1.63917 1.6665 1.74967C1.6665 1.86018 1.7104 1.96616 1.78854 2.0443C1.86668 2.12244 1.97266 2.16634 2.08317 2.16634H2.18734C2.21496 2.16634 2.24146 2.17732 2.26099 2.19685C2.28053 2.21639 2.2915 2.24288 2.2915 2.27051V3.72884C2.2915 3.75647 2.28053 3.78296 2.26099 3.8025C2.24146 3.82203 2.21496 3.83301 2.18734 3.83301H2.08317C1.97266 3.83301 1.86668 3.87691 1.78854 3.95505C1.7104 4.03319 1.6665 4.13917 1.6665 4.24967C1.6665 4.36018 1.7104 4.46616 1.78854 4.5443C1.86668 4.62244 1.97266 4.66634 2.08317 4.66634H3.33317C3.44368 4.66634 3.54966 4.62244 3.6278 4.5443C3.70594 4.46616 3.74984 4.36018 3.74984 4.24967C3.74984 4.13917 3.70594 4.03319 3.6278 3.95505C3.54966 3.87691 3.44368 3.83301 3.33317 3.83301H3.229C3.20138 3.83301 3.17488 3.82203 3.15535 3.8025C3.13581 3.78296 3.12484 3.75647 3.12484 3.72884V2.27051C3.12484 2.24288 3.13581 2.21639 3.15535 2.19685C3.17488 2.17732 3.20138 2.16634 3.229 2.16634H3.33317Z"
          fill={color}
          stroke="none"
        />
      </React.Fragment>
    ),
  },
  [IconShape.TEXT_AREA]: {
    baseWidth: 12,
    baseHeight: 8,
    render: (color) => (
      <React.Fragment>
        <path
          d="M10.5834 0.333008H1.41667C1.17356 0.333008 0.940396 0.429585 0.768487 0.601495C0.596578 0.773404 0.5 1.00656 0.5 1.24968L0.5 6.74971C0.5 6.99283 0.596578 7.22599 0.768487 7.39789C0.940396 7.5698 1.17356 7.66638 1.41667 7.66638H10.5834C10.8265 7.66638 11.0597 7.5698 11.2316 7.39789C11.4035 7.22599 11.5001 6.99283 11.5001 6.74971V1.24968C11.5001 1.00656 11.4035 0.773404 11.2316 0.601495C11.0597 0.429585 10.8265 0.333008 10.5834 0.333008ZM1.41667 6.29137V1.70802C1.41667 1.58646 1.46496 1.46988 1.55092 1.38392C1.63687 1.29797 1.75345 1.24968 1.87501 1.24968H10.1251C10.2466 1.24968 10.3632 1.29797 10.4491 1.38392C10.5351 1.46988 10.5834 1.58646 10.5834 1.70802V6.29137C10.5834 6.41293 10.5351 6.52951 10.4491 6.61547C10.3632 6.70142 10.2466 6.74971 10.1251 6.74971H1.87501C1.75345 6.74971 1.63687 6.70142 1.55092 6.61547C1.46496 6.52951 1.41667 6.41293 1.41667 6.29137Z"
          fill={color}
          stroke="none"
        />
        <path
          d="M2.3335 2.62467C2.3335 2.74623 2.38178 2.86281 2.46774 2.94876C2.55369 3.03472 2.67027 3.08301 2.79183 3.08301L9.20853 3.08301C9.33009 3.08301 9.44667 3.03472 9.53263 2.94876C9.61858 2.86281 9.66687 2.74623 9.66687 2.62467C9.66687 2.50311 9.61858 2.38653 9.53263 2.30058C9.44667 2.21462 9.33009 2.16634 9.20853 2.16634L2.79183 2.16634C2.67027 2.16634 2.55369 2.21462 2.46774 2.30058C2.38178 2.38653 2.3335 2.50311 2.3335 2.62467Z"
          fill={color}
          stroke="none"
        />
        <path
          d="M2.3335 3.99967C2.3335 4.12123 2.38178 4.23781 2.46774 4.32376C2.55369 4.40972 2.67027 4.45801 2.79183 4.45801L9.20853 4.45801C9.33009 4.45801 9.44667 4.40972 9.53263 4.32376C9.61858 4.23781 9.66687 4.12123 9.66687 3.99967C9.66687 3.87811 9.61858 3.76153 9.53263 3.67558C9.44667 3.58962 9.33009 3.54134 9.20853 3.54134L2.79183 3.54134C2.67027 3.54134 2.55369 3.58962 2.46774 3.67558C2.38178 3.76153 2.3335 3.87811 2.3335 3.99967Z"
          fill={color}
          stroke="none"
        />
        <path
          d="M2.3335 5.37467C2.3335 5.49623 2.38178 5.61281 2.46774 5.69876C2.55369 5.78472 2.67027 5.83301 2.79183 5.83301L6.00018 5.83301C6.12174 5.83301 6.23832 5.78472 6.32428 5.69876C6.41023 5.61281 6.45852 5.49623 6.45852 5.37467C6.45852 5.25311 6.41023 5.13653 6.32428 5.05058C6.23832 4.96462 6.12174 4.91634 6.00018 4.91634L2.79183 4.91634C2.67027 4.91634 2.55369 4.96462 2.46774 5.05058C2.38178 5.13653 2.3335 5.25311 2.3335 5.37467Z"
          fill={color}
          stroke="none"
        />
      </React.Fragment>
    ),
  },
  [IconShape.CHECK_BOX]: {
    baseWidth: 8,
    baseHeight: 8,
    render: (color) => (
      <React.Fragment>
        <path
          d="M5.96559 2.31946C5.88772 2.26298 5.79068 2.23956 5.69562 2.25431C5.60056 2.26906 5.51518 2.32079 5.45809 2.39821L3.63809 4.87446L2.47142 3.94405C2.39407 3.88371 2.29591 3.85657 2.19855 3.86861C2.10119 3.88064 2.01259 3.93086 1.95226 4.00821C1.89192 4.08557 1.86478 4.18372 1.87682 4.28109C1.88885 4.37845 1.93907 4.46704 2.01642 4.52738L3.47476 5.69405C3.54348 5.73966 3.6262 5.7593 3.70809 5.74946C3.76465 5.74924 3.8204 5.73596 3.87098 5.71067C3.92157 5.68537 3.96564 5.64874 3.99976 5.60363L6.04142 2.8328C6.07045 2.79423 6.09153 2.75028 6.10344 2.7035C6.11535 2.65671 6.11785 2.60803 6.11079 2.56028C6.10374 2.51253 6.08727 2.46665 6.06234 2.42531C6.03742 2.38397 6.00453 2.34799 5.96559 2.31946Z"
          fill={color}
          stroke="none"
        />
        <path
          d="M6.91667 0.5H1.08333C0.928624 0.5 0.780251 0.561458 0.670854 0.670854C0.561458 0.780251 0.5 0.928624 0.5 1.08333L0.5 6.91667C0.5 7.07138 0.561458 7.21975 0.670854 7.32915C0.780251 7.43854 0.928624 7.5 1.08333 7.5H6.91667C7.07138 7.5 7.21975 7.43854 7.32915 7.32915C7.43854 7.21975 7.5 7.07138 7.5 6.91667V1.08333C7.5 0.928624 7.43854 0.780251 7.32915 0.670854C7.21975 0.561458 7.07138 0.5 6.91667 0.5V0.5ZM6.91667 6.84375C6.91667 6.86309 6.90898 6.88164 6.89531 6.89531C6.88164 6.90898 6.86309 6.91667 6.84375 6.91667H1.15625C1.13691 6.91667 1.11836 6.90898 1.10469 6.89531C1.09102 6.88164 1.08333 6.86309 1.08333 6.84375V1.15625C1.08333 1.13691 1.09102 1.11836 1.10469 1.10469C1.11836 1.09102 1.13691 1.08333 1.15625 1.08333H6.84375C6.86309 1.08333 6.88164 1.09102 6.89531 1.10469C6.90898 1.11836 6.91667 1.13691 6.91667 1.15625V6.84375Z"
          fill={color}
          stroke="none"
        />
      </React.Fragment>
    ),
  },
  [IconShape.RADIO_BUTTON]: {
    baseWidth: 10,
    baseHeight: 10,
    render: (color) => (
      <React.Fragment>
        <path
          d="M2.40039 7.59961C3.13086 8.31576 3.9974 8.67383 5 8.67383C6.0026 8.67383 6.86198 8.31576 7.57812 7.59961C8.30859 6.86914 8.67383 6.0026 8.67383 5C8.67383 3.9974 8.30859 3.13802 7.57812 2.42188C6.86198 1.69141 6.0026 1.32617 5 1.32617C3.9974 1.32617 3.13086 1.69141 2.40039 2.42188C1.68424 3.13802 1.32617 3.9974 1.32617 5C1.32617 6.0026 1.68424 6.86914 2.40039 7.59961ZM1.75586 1.77734C2.6582 0.875 3.73958 0.423828 5 0.423828C6.26042 0.423828 7.33464 0.875 8.22266 1.77734C9.125 2.66536 9.57617 3.73958 9.57617 5C9.57617 6.26042 9.125 7.3418 8.22266 8.24414C7.33464 9.13216 6.26042 9.57617 5 9.57617C3.73958 9.57617 2.6582 9.13216 1.75586 8.24414C0.867839 7.3418 0.423828 6.26042 0.423828 5C0.423828 3.73958 0.867839 2.66536 1.75586 1.77734ZM3.36719 3.38867C3.82552 2.93034 4.36979 2.70117 5 2.70117C5.63021 2.70117 6.16732 2.93034 6.61133 3.38867C7.06966 3.83268 7.29883 4.36979 7.29883 5C7.29883 5.63021 7.06966 6.17448 6.61133 6.63281C6.16732 7.07682 5.63021 7.29883 5 7.29883C4.36979 7.29883 3.82552 7.07682 3.36719 6.63281C2.92318 6.17448 2.70117 5.63021 2.70117 5C2.70117 4.36979 2.92318 3.83268 3.36719 3.38867Z"
          fill={color}
          stroke="none"
        />
      </React.Fragment>
    ),
  },
  [IconShape.SINGLE_SELECT]: {
    baseWidth: 12,
    baseHeight: 8,
    render: (color) => (
      <React.Fragment>
        <path
          d="M1 1.5C1 1.22386 1.22386 1 1.5 1H10.5C10.7761 1 11 1.22386 11 1.5V6.5C11 6.77614 10.7761 7 10.5 7H1.5C1.22386 7 1 6.77614 1 6.5V1.5Z"
          stroke={color}
          fill="none"
        />
      </React.Fragment>
    ),
  },
  [IconShape.LINE_ARROW_DOWN]: {
    baseWidth: 8,
    baseHeight: 5,
    render: (color) => (
      <React.Fragment>
        <path
          d="M3.64645 4.35355C3.84171 4.54882 4.15829 4.54882 4.35355 4.35355L7.53553 1.17157C7.7308 0.976311 7.7308 0.659728 7.53553 0.464466C7.34027 0.269204 7.02369 0.269204 6.82843 0.464466L4 3.29289L1.17157 0.464466C0.976311 0.269204 0.659728 0.269204 0.464466 0.464466C0.269204 0.659728 0.269204 0.976311 0.464466 1.17157L3.64645 4.35355ZM4.5 4L4.5 3L3.5 3L3.5 4L4.5 4Z"
          fill={color}
          stroke="none"
        />
      </React.Fragment>
    ),
  },
  [IconShape.REPLAY_SMALL]: {
    baseWidth: 10,
    baseHeight: 13,
    render: (color) => (
      <React.Fragment>
        <path
          d="M5 2.92578C6.29427 2.92578 7.39714 3.38151 8.30859 4.29297C9.22005 5.20443 9.67578 6.29818 9.67578 7.57422C9.67578 8.86849 9.21094 9.97135 8.28125 10.8828C7.36979 11.7943 6.27604 12.25 5 12.25C3.72396 12.25 2.62109 11.7943 1.69141 10.8828C0.779948 9.97135 0.324219 8.86849 0.324219 7.57422H1.5C1.5 8.54036 1.83724 9.36979 2.51172 10.0625C3.20443 10.737 4.03385 11.0742 5 11.0742C5.96615 11.0742 6.78646 10.737 7.46094 10.0625C8.15365 9.36979 8.5 8.54036 8.5 7.57422C8.5 6.60807 8.15365 5.78776 7.46094 5.11328C6.78646 4.42057 5.96615 4.07422 5 4.07422V6.42578L2.07422 3.5L5 0.574219V2.92578Z"
          fill={color}
          stroke="none"
        />
      </React.Fragment>
    ),
  },
  [IconShape.BROWSER]: {
    baseWidth: 36,
    baseHeight: 36,
    render: (color) => (
      <React.Fragment>
        <path
          d="M35.0106 8.13574V31.8024C35.0106 32.587 34.6989 33.3395 34.1441 33.8943C33.5893 34.4491 32.8368 34.7607 32.0522 34.7607H3.94808C3.16348 34.7607 2.41102 34.4491 1.85622 33.8943C1.30143 33.3395 0.989746 32.587 0.989746 31.8024V8.13574H35.0106Z"
          fill="transparent"
        />
        <path
          d="M32.0522 0.73999H3.94808C2.31424 0.73999 0.989746 2.06448 0.989746 3.69832V31.8025C0.989746 33.4363 2.31424 34.7608 3.94808 34.7608H32.0522C33.6861 34.7608 35.0106 33.4363 35.0106 31.8025V3.69832C35.0106 2.06448 33.6861 0.73999 32.0522 0.73999Z"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.989746 8.13574H35.0106"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.16691 4.06812C6.24005 4.06812 6.31154 4.0898 6.37236 4.13044C6.43317 4.17107 6.48057 4.22882 6.50855 4.29639C6.53654 4.36396 6.54387 4.43832 6.5296 4.51005C6.51533 4.58178 6.48011 4.64767 6.42839 4.69939C6.37668 4.75111 6.31079 4.78632 6.23905 4.80059C6.16732 4.81486 6.09297 4.80754 6.0254 4.77955C5.95783 4.75156 5.90007 4.70416 5.85944 4.64335C5.81881 4.58254 5.79712 4.51104 5.79712 4.43791C5.79712 4.33983 5.83608 4.24577 5.90543 4.17642C5.97478 4.10708 6.06884 4.06812 6.16691 4.06812"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6044 4.06812C10.6775 4.06812 10.749 4.0898 10.8099 4.13044C10.8707 4.17107 10.9181 4.22882 10.9461 4.29639C10.974 4.36396 10.9814 4.43832 10.9671 4.51005C10.9528 4.58178 10.9176 4.64767 10.8659 4.69939C10.8142 4.75111 10.7483 4.78632 10.6766 4.80059C10.6048 4.81486 10.5305 4.80754 10.4629 4.77955C10.3953 4.75156 10.3376 4.70416 10.2969 4.64335C10.2563 4.58254 10.2346 4.51104 10.2346 4.43791C10.2346 4.33983 10.2736 4.24577 10.3429 4.17642C10.4123 4.10708 10.5063 4.06812 10.6044 4.06812Z"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0419 4.06812C15.115 4.06812 15.1865 4.0898 15.2474 4.13044C15.3082 4.17107 15.3556 4.22882 15.3836 4.29639C15.4115 4.36396 15.4189 4.43832 15.4046 4.51005C15.3903 4.58178 15.3551 4.64767 15.3034 4.69939C15.2517 4.75111 15.1858 4.78632 15.1141 4.80059C15.0423 4.81486 14.968 4.80754 14.9004 4.77955C14.8328 4.75156 14.7751 4.70416 14.7344 4.64335C14.6938 4.58254 14.6721 4.51104 14.6721 4.43791C14.6721 4.33983 14.7111 4.24577 14.7804 4.17642C14.8498 4.10708 14.9438 4.06812 15.0419 4.06812Z"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.8335 12.5732H6.16683C5.75837 12.5732 5.42725 12.9044 5.42725 13.3128V16.2712C5.42725 16.6796 5.75837 17.0107 6.16683 17.0107H29.8335C30.242 17.0107 30.5731 16.6796 30.5731 16.2712V13.3128C30.5731 12.9044 30.242 12.5732 29.8335 12.5732Z"
          fill="transparent"
        />
        <path
          d="M6.16683 12.5732C5.97068 12.5732 5.78256 12.6512 5.64387 12.7899C5.50517 12.9286 5.42725 13.1167 5.42725 13.3128V16.2712C5.42725 16.4673 5.50517 16.6554 5.64387 16.7941C5.78256 16.9328 5.97068 17.0107 6.16683 17.0107H23.1772L27.6147 12.5732H6.16683Z"
          fill="transparent"
        />
        <path
          d="M29.8335 12.5732H6.16683C5.75837 12.5732 5.42725 12.9044 5.42725 13.3128V16.2712C5.42725 16.6796 5.75837 17.0107 6.16683 17.0107H29.8335C30.242 17.0107 30.5731 16.6796 30.5731 16.2712V13.3128C30.5731 12.9044 30.242 12.5732 29.8335 12.5732Z"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.12516 19.9692H6.16683C5.75837 19.9692 5.42725 20.3004 5.42725 20.7088V29.5838C5.42725 29.9923 5.75837 30.3234 6.16683 30.3234H9.12516C9.53362 30.3234 9.86475 29.9923 9.86475 29.5838V20.7088C9.86475 20.3004 9.53362 19.9692 9.12516 19.9692Z"
          fill="transparent"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3022 21.4482H29.0939"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3022 24.4067H29.0939"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3022 27.365H29.0939"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3022 30.3232H24.6564"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </React.Fragment>
    ),
  },
  [IconShape.FILE_CODE]: {
    baseWidth: 30,
    baseHeight: 36,
    render: (color) => (
      <React.Fragment>
        <path
          d="M12.0416 13.3186L6.8645 18.4957L12.0416 23.6728"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.9583 13.3186L23.1353 18.4957L17.9583 23.6728"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.6185 6.65666C28.8959 6.93399 29.0518 7.31016 29.0519 7.70243V33.2817C29.0519 33.674 28.8961 34.0502 28.6187 34.3276C28.3413 34.605 27.9651 34.7608 27.5728 34.7608H2.42692C2.03462 34.7608 1.65839 34.605 1.38099 34.3276C1.10359 34.0502 0.947754 33.674 0.947754 33.2817V2.21916C0.947754 1.82686 1.10359 1.45063 1.38099 1.17323C1.65839 0.895831 2.03462 0.73999 2.42692 0.73999H22.0895C22.2844 0.741388 22.4772 0.781312 22.6567 0.857467C22.8361 0.933622 22.9988 1.04451 23.1353 1.18374L28.6185 6.65666Z"
          stroke={color}
          strokeWidth="1.47917"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </React.Fragment>
    ),
  },
  [IconShape.MICROPHONE]: {
    baseWidth: 30,
    baseHeight: 30,
    render: (color) => (
      <React.Fragment>
        <path
          fill={color}
          d="M22.7183 14.2222H25.2903C25.2903 16.8889 24.3854 19.2346 22.5754 21.2593C20.8132 23.2346 18.6698 24.4198 16.1455 24.8148V30H13.1448V24.8148C10.6205 24.4198 8.45334 23.2346 6.64343 21.2593C4.88114 19.2346 4 16.8889 4 14.2222H6.57199C6.57199 16.5432 7.35787 18.4691 8.92964 20C10.549 21.4815 12.4542 22.2222 14.6452 22.2222C16.8361 22.2222 18.7175 21.4815 20.2892 20C21.9086 18.4691 22.7183 16.5432 22.7183 14.2222ZM17.8601 17.5556C16.9552 18.4938 15.8835 18.963 14.6452 18.963C13.4068 18.963 12.3351 18.4938 11.4302 17.5556C10.5252 16.6173 10.0727 15.5062 10.0727 14.2222V4.74074C10.0727 3.45679 10.5252 2.34568 11.4302 1.40741C12.3351 0.469136 13.4068 0 14.6452 0C15.8835 0 16.9552 0.469136 17.8601 1.40741C18.7651 2.34568 19.2176 3.45679 19.2176 4.74074V14.2222C19.2176 15.5062 18.7651 16.6173 17.8601 17.5556Z"
        />
      </React.Fragment>
    ),
  },
  [IconShape.LINK]: {
    baseWidth: 20,
    baseHeight: 20,
    render: (color) => (
      <React.Fragment>
        <path
          color={color}
          d="M13.7617 6.23828C14.793 6.23828 15.6719 6.61328 16.3984 7.36328C17.125 8.08984 17.4883 8.96875 17.4883 10C17.4883 11.0312 17.125 11.9219 16.3984 12.6719C15.6719 13.3984 14.793 13.7617 13.7617 13.7617H10.7383V12.3203H13.7617C14.3945 12.3203 14.9336 12.0977 15.3789 11.6523C15.8477 11.1836 16.082 10.6328 16.082 10C16.082 9.36719 15.8477 8.82812 15.3789 8.38281C14.9336 7.91406 14.3945 7.67969 13.7617 7.67969H10.7383V6.23828H13.7617ZM7.01172 10.7383V9.26172H12.9883V10.7383H7.01172ZM4.58594 8.38281C4.14062 8.82812 3.91797 9.36719 3.91797 10C3.91797 10.6328 4.14062 11.1836 4.58594 11.6523C5.05469 12.0977 5.60547 12.3203 6.23828 12.3203H9.26172V13.7617H6.23828C5.20703 13.7617 4.32812 13.3984 3.60156 12.6719C2.875 11.9219 2.51172 11.0312 2.51172 10C2.51172 8.96875 2.875 8.08984 3.60156 7.36328C4.32812 6.61328 5.20703 6.23828 6.23828 6.23828H9.26172V7.67969H6.23828C5.60547 7.67969 5.05469 7.91406 4.58594 8.38281Z"
        />
      </React.Fragment>
    ),
  },
  [IconShape.PREV]: {
    baseWidth: 30,
    baseHeight: 30,
    render: (color) => (
      <React.Fragment>
        <path d="M20.438 9L11.0152 15L20.438 21V9Z" fill={color} />
      </React.Fragment>
    ),
  },
  [IconShape.NEXT]: {
    baseWidth: 30,
    baseHeight: 30,
    render: (color) => (
      <React.Fragment>
        <path d="M11.0151 9L20.438 15L11.0151 21V9Z" fill={color} />
      </React.Fragment>
    ),
  },
  [IconShape.TIKTOK]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M17.658 6.84956C17.5365 6.78677 17.4182 6.71793 17.3036 6.64332C16.9704 6.423 16.6648 6.1634 16.3935 5.87011C15.7148 5.09352 15.4613 4.30568 15.368 3.75409H15.3717C15.2937 3.29624 15.326 3 15.3309 3H12.2395V14.9537C12.2395 15.1141 12.2395 15.2728 12.2328 15.4295C12.2328 15.449 12.2309 15.467 12.2298 15.488C12.2298 15.4966 12.2298 15.5056 12.2279 15.5146C12.2279 15.5169 12.2279 15.5191 12.2279 15.5214C12.1953 15.9503 12.0578 16.3646 11.8275 16.7279C11.5972 17.0912 11.2812 17.3923 10.9072 17.6048C10.5174 17.8265 10.0766 17.9428 9.62814 17.9423C8.18783 17.9423 7.02052 16.7678 7.02052 15.3174C7.02052 13.867 8.18783 12.6925 9.62814 12.6925C9.90078 12.6923 10.1717 12.7352 10.431 12.8196L10.4347 9.67204C9.64777 9.57039 8.8483 9.63293 8.08673 9.85572C7.32516 10.0785 6.61803 10.4567 6.00994 10.9665C5.47712 11.4294 5.02917 11.9818 4.68626 12.5988C4.55576 12.8238 4.06341 13.7278 4.00379 15.1951C3.96629 16.028 4.21641 16.8908 4.33565 17.2474V17.2549C4.41065 17.4649 4.70126 18.1815 5.17486 18.7856C5.55675 19.2702 6.00795 19.6958 6.51392 20.0489V20.0414L6.52142 20.0489C8.01797 21.0658 9.67726 20.9991 9.67726 20.9991C9.96449 20.9875 10.9267 20.9991 12.0194 20.4813C13.2313 19.9072 13.9213 19.0518 13.9213 19.0518C14.3621 18.5408 14.7126 17.9583 14.9577 17.3295C15.2375 16.5942 15.3309 15.7122 15.3309 15.3598V9.01807C15.3683 9.04057 15.8678 9.37093 15.8678 9.37093C15.8678 9.37093 16.5874 9.83216 17.7101 10.1325C18.5156 10.3463 19.6008 10.3913 19.6008 10.3913V7.32241C19.2205 7.36366 18.4484 7.24366 17.658 6.84956Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.FACEBOOK]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M21 12.0546C21 7.0536 16.971 3 12 3C7.029 3 3 7.0536 3 12.0546C3 16.575 6.2904 20.3208 10.5936 21V14.6724H8.3088V12.054H10.5936V10.0596C10.5936 7.7904 11.937 6.5364 13.9932 6.5364C14.9772 6.5364 16.008 6.7134 16.008 6.7134V8.9418H14.8722C13.7544 8.9418 13.4064 9.6402 13.4064 10.3566V12.0546H15.9024L15.5034 14.6718H13.4064V21C17.7096 20.3208 21 16.575 21 12.0546Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.INSTAGRAM]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3C9.5556 3 9.2496 3.0102 8.2896 3.054C7.3314 3.0978 6.6768 3.2502 6.1044 3.4728C5.5044 3.6984 4.9602 4.0524 4.5102 4.5108C4.05253 4.96028 3.69831 5.5041 3.4722 6.1044C3.2508 6.6768 3.0978 7.332 3.054 8.2902C3.0108 9.2496 3 9.555 3 12C3 14.445 3.0102 14.7504 3.054 15.7104C3.0978 16.6686 3.2502 17.3232 3.4728 17.8956C3.6984 18.4956 4.0524 19.0398 4.5108 19.4898C4.96029 19.9475 5.50411 20.3017 6.1044 20.5278C6.6768 20.7498 7.3314 20.9022 8.2896 20.946C9.2496 20.9898 9.5556 21 12 21C14.4444 21 14.7504 20.9898 15.7104 20.946C16.6686 20.9022 17.3232 20.7498 17.8956 20.5272C18.4956 20.3016 19.0398 19.9476 19.4898 19.4892C19.9475 19.0397 20.3017 18.4959 20.5278 17.8956C20.7498 17.3232 20.9022 16.6686 20.946 15.7104C20.9898 14.7504 21 14.4444 21 12C21 9.5556 20.9898 9.2496 20.946 8.2896C20.9022 7.3314 20.7498 6.6768 20.5272 6.1044C20.3012 5.50384 19.947 4.95979 19.4892 4.5102C19.0397 4.05253 18.4959 3.69831 17.8956 3.4722C17.3232 3.2508 16.668 3.0978 15.7098 3.054C14.7504 3.0108 14.445 3 12 3ZM12 4.6218C14.403 4.6218 14.688 4.6308 15.6372 4.674C16.5144 4.7142 16.9908 4.86 17.3082 4.9842C17.7282 5.1468 18.0282 5.3424 18.3432 5.6568C18.6582 5.9718 18.8532 6.2718 19.0158 6.6918C19.1394 7.0092 19.2858 7.4856 19.326 8.3628C19.3692 9.312 19.3782 9.597 19.3782 12C19.3782 14.403 19.3692 14.688 19.326 15.6372C19.2858 16.5144 19.14 16.9908 19.0158 17.3082C18.8718 17.6991 18.6419 18.0528 18.3432 18.3432C18.0528 18.642 17.6992 18.8718 17.3082 19.0158C16.9908 19.1394 16.5144 19.2858 15.6372 19.326C14.688 19.3692 14.4036 19.3782 12 19.3782C9.5964 19.3782 9.312 19.3692 8.3628 19.326C7.4856 19.2858 7.0092 19.14 6.6918 19.0158C6.30087 18.8718 5.9472 18.6419 5.6568 18.3432C5.35811 18.0528 5.12828 17.6991 4.9842 17.3082C4.8606 16.9908 4.7142 16.5144 4.674 15.6372C4.6308 14.688 4.6218 14.403 4.6218 12C4.6218 9.597 4.6308 9.312 4.674 8.3628C4.7142 7.4856 4.86 7.0092 4.9842 6.6918C5.1468 6.2718 5.3424 5.9718 5.6568 5.6568C5.94716 5.35803 6.30085 5.12819 6.6918 4.9842C7.0092 4.8606 7.4856 4.7142 8.3628 4.674C9.312 4.6308 9.597 4.6218 12 4.6218Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 15.003C11.6056 15.003 11.2151 14.9253 10.8508 14.7744C10.4865 14.6235 10.1554 14.4023 9.87656 14.1234C9.5977 13.8446 9.3765 13.5135 9.22559 13.1492C9.07467 12.7849 8.997 12.3944 8.997 12C8.997 11.6056 9.07467 11.2151 9.22559 10.8508C9.3765 10.4865 9.5977 10.1554 9.87656 9.87656C10.1554 9.5977 10.4865 9.37651 10.8508 9.22559C11.2151 9.07468 11.6056 8.997 12 8.997C12.7964 8.997 13.5603 9.31339 14.1234 9.87656C14.6866 10.4397 15.003 11.2036 15.003 12C15.003 12.7964 14.6866 13.5603 14.1234 14.1234C13.5603 14.6866 12.7964 15.003 12 15.003ZM12 7.374C10.7731 7.374 9.59647 7.86138 8.72892 8.72892C7.86138 9.59647 7.374 10.7731 7.374 12C7.374 13.2269 7.86138 14.4035 8.72892 15.2711C9.59647 16.1386 10.7731 16.626 12 16.626C13.2269 16.626 14.4035 16.1386 15.2711 15.2711C16.1386 14.4035 16.626 13.2269 16.626 12C16.626 10.7731 16.1386 9.59647 15.2711 8.72892C14.4035 7.86138 13.2269 7.374 12 7.374ZM17.9718 7.29C17.9718 7.58001 17.8566 7.85815 17.6515 8.06322C17.4464 8.26829 17.1683 8.3835 16.8783 8.3835C16.5883 8.3835 16.3101 8.26829 16.1051 8.06322C15.9 7.85815 15.7848 7.58001 15.7848 7.29C15.7848 6.99999 15.9 6.72185 16.1051 6.51678C16.3101 6.31171 16.5883 6.1965 16.8783 6.1965C17.1683 6.1965 17.4464 6.31171 17.6515 6.51678C17.8566 6.72185 17.9718 6.99999 17.9718 7.29Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.YOUTUBE]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.0128 6.38126C19.7869 6.58921 20.3992 7.20154 20.6072 7.97561C20.9884 9.38511 21 12.3081 21 12.3081C21 12.3081 21 15.2426 20.6187 16.6406C20.4108 17.4146 19.7985 18.027 19.0244 18.2349C17.6264 18.6162 12 18.6162 12 18.6162C12 18.6162 6.37356 18.6162 4.97561 18.2349C4.20154 18.027 3.58922 17.4146 3.38126 16.6406C3 15.2311 3 12.3081 3 12.3081C3 12.3081 3 9.38511 3.3697 7.98716C3.57766 7.21309 4.18999 6.60077 4.96406 6.39281C6.362 6.01155 11.9884 6 11.9884 6C11.9884 6 17.6149 6 19.0128 6.38126ZM14.8652 12.3081L10.1977 15.0116V9.60462L14.8652 12.3081Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.X]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M13.7142 10.6226L20.4162 3H18.8286L13.0068 9.61726L8.3604 3H3L10.0278 13.0074L3 20.9999H4.5876L10.7316 14.0104L15.6396 20.9999H21M5.1606 4.17142H7.5996L18.8274 19.8861H16.3878"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.PLAY]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path d="M8 6L17.1406 11.8203L8 17.6406V6Z" fill={color} />
      </React.Fragment>
    ),
  },
  [IconShape.ALERT_EMPTY]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M15 16.1094V11.1094C15 10.0417 14.7005 9.15625 14.1016 8.45312C13.5026 7.72396 12.6953 7.35938 11.6797 7.35938C10.6641 7.35938 9.85677 7.72396 9.25781 8.45312C8.65885 9.15625 8.35938 10.0417 8.35938 11.1094V16.1094H15ZM16.6797 15.25L18.3594 16.9297V17.75H5V16.9297L6.67969 15.25V11.1094C6.67969 9.80729 7.00521 8.67448 7.65625 7.71094C8.33333 6.7474 9.25781 6.1224 10.4297 5.83594V5.25C10.4297 4.91146 10.5469 4.625 10.7812 4.39062C11.0156 4.13021 11.3151 4 11.6797 4C12.0443 4 12.3438 4.13021 12.5781 4.39062C12.8125 4.625 12.9297 4.91146 12.9297 5.25V5.83594C14.1016 6.1224 15.013 6.7474 15.6641 7.71094C16.3411 8.67448 16.6797 9.80729 16.6797 11.1094V15.25ZM12.8516 19.7812C12.513 20.0938 12.1224 20.25 11.6797 20.25C11.237 20.25 10.8464 20.0938 10.5078 19.7812C10.1693 19.4427 10 19.0521 10 18.6094H13.3594C13.3594 19.0521 13.1901 19.4427 12.8516 19.7812Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.ALERT_FULL]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M16.6797 15.25L18.3594 16.9297V17.75H5V16.9297L6.67969 15.25V11.1094C6.67969 9.80729 7.00521 8.67448 7.65625 7.71094C8.33333 6.7474 9.25781 6.1224 10.4297 5.83594V5.25C10.4297 4.91146 10.5469 4.625 10.7812 4.39062C11.0156 4.13021 11.3151 4 11.6797 4C12.0443 4 12.3438 4.13021 12.5781 4.39062C12.8125 4.625 12.9297 4.91146 12.9297 5.25V5.83594C14.1016 6.1224 15.013 6.7474 15.6641 7.71094C16.3411 8.67448 16.6797 9.80729 16.6797 11.1094V15.25ZM11.6797 20.25C11.2109 20.25 10.8073 20.0938 10.4688 19.7812C10.1562 19.4688 10 19.0781 10 18.6094H13.3594C13.3594 19.0521 13.1901 19.4427 12.8516 19.7812C12.513 20.0938 12.1224 20.25 11.6797 20.25Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.LOGO_FULL]: {
    baseWidth: 285,
    baseHeight: 67,
    render: (color) => (
      <React.Fragment>
        <path
          d="M0 0V67H285V0H0ZM276.004 58.0405H8.97491V8.98023H276.025V58.0405H276.004Z"
          fill={color}
        />
        <path
          d="M246.53 37.39H246.551V49.1016H255.526L255.505 37.39H255.526H255.505L266.781 17.8984H257.806L251.028 29.6306L244.25 17.8984H235.254L246.53 37.39Z"
          fill={color}
        />
        <path
          d="M159.973 49.1016H189.178L192.784 39.8731H205.2L210.527 49.1016H223.875C231.213 49.1016 237.949 44.239 239.524 37.0797C241.763 26.9821 234.094 17.8984 224.331 17.8984H210.817V34.1L201.428 17.8984H192.453L182.732 42.6044H168.927V39.8524H182.213V33.4172H168.927V24.3335H184.286V17.8984H159.932V49.1016H159.973ZM219.813 24.4577H224.331H222.134C227.171 24.4577 231.254 28.534 231.254 33.5621C231.254 38.5902 227.171 42.6458 222.155 42.6664H219.833V24.4784L219.813 24.4577ZM197.863 27.0028L201.573 33.4172H195.375L197.863 27.0028Z"
          fill={color}
        />
        <path
          d="M141.961 49.1016V39.9351H145.692L150.978 49.1016H159.952L153.921 38.6522C157.486 36.852 159.973 33.1896 159.973 28.9064C159.973 22.8437 155.061 17.9191 148.988 17.9191H132.986V49.1223H141.961V49.1016ZM141.961 24.3542H146.19C148.324 24.3542 150.314 25.6992 150.812 27.7684C151.537 30.7687 149.278 33.4379 146.397 33.4379V33.5H141.961V24.3749V24.3542Z"
          fill={color}
        />
        <path
          d="M126.043 49.1016V42.6251H110.684V39.8731H123.97V33.4379H110.684V24.3542H126.043V17.8984H110.684H101.688V49.1016H101.709H126.043Z"
          fill={color}
        />
        <path
          d="M99.6151 17.8984H90.6401V49.1016H99.6151V17.8984Z"
          fill={color}
        />
        <path
          d="M25.9298 33.4379L34.6353 48.4808L43.3407 33.4379V49.1016H56.2745L59.8811 39.8731H72.2967L75.1364 44.7977L72.6491 49.1223H81.624L90.6404 33.5207L81.6447 17.9191H72.6698L81.6655 33.5207L79.6342 37.059L68.5658 17.9398H59.5909L52.3571 36.3348V17.9398H43.3822L34.6975 32.962L25.992 17.9398H17.0171V49.143H25.992V33.4793L25.9298 33.4379ZM64.9385 27.0028L68.6487 33.4172H62.4513L64.9385 27.0028Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
  [IconShape.DOT_MENU]: {
    baseWidth: 24,
    baseHeight: 24,
    render: (color) => (
      <React.Fragment>
        <path
          d="M10.9474 10.4561C11.2515 10.152 11.6023 10 12 10C12.3977 10 12.7485 10.152 13.0526 10.4561C13.3567 10.7602 13.5088 11.1111 13.5088 11.5088C13.5088 11.9064 13.3567 12.2573 13.0526 12.5614C12.7485 12.8655 12.3977 13.0175 12 13.0175C11.6023 13.0175 11.2515 12.8655 10.9474 12.5614C10.6433 12.2573 10.4912 11.9064 10.4912 11.5088C10.4912 11.1111 10.6433 10.7602 10.9474 10.4561ZM15.4386 10.4561C15.7427 10.152 16.0936 10 16.4912 10C16.8889 10 17.2398 10.152 17.5439 10.4561C17.848 10.7602 18 11.1111 18 11.5088C18 11.9064 17.848 12.2573 17.5439 12.5614C17.2398 12.8655 16.8889 13.0175 16.4912 13.0175C16.0936 13.0175 15.7427 12.8655 15.4386 12.5614C15.1345 12.2573 14.9825 11.9064 14.9825 11.5088C14.9825 11.1111 15.1345 10.7602 15.4386 10.4561ZM6.45614 10.4561C6.76023 10.152 7.11111 10 7.50877 10C7.90643 10 8.25731 10.152 8.5614 10.4561C8.8655 10.7602 9.01754 11.1111 9.01754 11.5088C9.01754 11.9064 8.8655 12.2573 8.5614 12.5614C8.25731 12.8655 7.90643 13.0175 7.50877 13.0175C7.11111 13.0175 6.76023 12.8655 6.45614 12.5614C6.15205 12.2573 6 11.9064 6 11.5088C6 11.1111 6.15205 10.7602 6.45614 10.4561Z"
          fill={color}
        />
      </React.Fragment>
    ),
  },
};
